import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=35cf1249&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=35cf1249&prod&lang=css"
import style1 from "./styles.scss?vue&type=style&index=1&id=35cf1249&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf1249",
  null
  
)

export default component.exports